<!--
title:面包屑名称
type: 1:蓝色背景，0白色背景
path: 面包屑链接需要加'/'
 -->
<template>
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item  :to="{ path: item.path }" v-for="(item,index) in breadcrumbConfig.list" :key="index">
          <div :class="item.type==1?'secondLevel':'stair'">{{item.title}}</div>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 面包屑导航 -->
</template>
<script>
export default {
  name: 'breadcrumb',
  props: {
    breadcrumbConfig: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {

    }
  },
  created () {},
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.border {
  margin-left: 5px;
}
.stair {
  margin-left: -16px;
  background: url(../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}
.secondLevel {
  margin-left: -16px;
  background: url(../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}
</style>
